import { OnboardingProgressChecklist } from '@/view/features/onboarding/OnboardingProgressChecklist';
import { useOnboardingChecklistViewModel } from '@/viewmodel/features/onboarding';
import { createPortal } from 'react-dom';

export function OnboardingOverlay() {
  const { showCard, steps, percent } = useOnboardingChecklistViewModel();

  if (!showCard) return null;

  return createPortal(
    <div className="fixed bottom-6 right-6 z-50">
      <OnboardingProgressChecklist steps={steps} percent={percent} />
    </div>,
    document.body,
  );
}
